import { RIsolantECS_Type } from '@batical/types/src'
import { fetchGenericSorted, fetchGeneric } from './GenericQ'
const RIsolantECS = require('../json/IsolantECS.json')
//RPerteChargeAccident
export function fetchIsolantSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(RIsolantECS)
}

export function fetchIsolant(uuid: string): RIsolantECS_Type {
  return fetchGeneric(RIsolantECS, uuid)
}
